<template>
	<v-layout justify-center>
		
	<!--v-container grid-list-md text-xs-center-->
		 
 			<v-container>
	 			 <video v-if="!isBeingReplaced"  controls>
	 			 	<source :src="`${api}` + parseFile(video.path)">
				 </video>
				 <Upload
						v-if="isBeingReplaced"
						upload="files/uploadVideoEdit"
						button-text="Upload one video file"
						instruction-text="You can upload one (mp4) video file by dropping it here"
						set-valid="checkpointsValidator/setValidEdit"
						:max-files="1"
						:validate-num-of-files="validateNumOfFiles"
						validate-method="checkpointsValidator/validateVideoTaskEdit"
				></Upload>

				<div style="clear:both;"></div>


	 			
				<v-btn flat small @click="isBeingReplaced = true" v-if="!isBeingReplaced" style="margin-top:1em; text-align:center" color="primary" small>
		 			 	<v-icon>backup</v-icon>
		 			 	&nbsp;
		 			 	{{translater.__('Upload', 'routes')}}
		 			 	
		 		</v-btn>
				<v-btn flat  @click="isBeingReplaced = false" v-if="isBeingReplaced" style="margin-top:1em; text-align:center" color="primary" small>
					<v-icon>cancel</v-icon>
					&nbsp;
					{{translater.__('Cancel')}}

				</v-btn>

		 		<v-card>
		 			<v-card-actions>
		 				<!--v-btn :disabled="!valid" @click="update()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="update"></SuccessButton>
			        	<!--v-btn @click="edit = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => edit = false"></ErrorButton>
		 			</v-card-actions>
		 		</v-card>

		 	</v-container>

 		

 		



	 	
	 	
		

 	</v-layout>
</template>



<script>

	import {parseFileName} from '../../../tools';
	import fileTools from '../../../tools/files'
	
	import {APIURL} from '../../../constants'
	import Upload from './Upload';
	import SuccessButton from '../../../common/components/SuccessButton'
	import ErrorButton from '../../../common/components/ErrorButton'

	export default {
		name: 'EditVideoTask',
		components: {ErrorButton, SuccessButton, Upload},

		methods: {

			validateNumOfFiles(files, cb)
			{
				let valid = files.length === 1;
				cb(valid)
			},

			parseFile(f)
			{
				return parseFileName(f)
			},

			update()
			{
				this.$store.dispatch('checkpoints/updateTask');
			}
		},

		computed: {

			taskType: {
				get()
				{
					return this.$store.getters['checkpoints/editableTask'].type
				}
			},

			validExtensions: {
				get()
				{
					const {validExtensions} = fileTools.getValidExtensions(this.taskType,
							this.$store.getters['files/validMimeTypes'])

					return validExtensions.join(', ')
				}
			},

			edit:{
				get()
				{
					return this.$store.getters['checkpoints/editTask'];
				},
				set(value)
				{
					this.$store.dispatch('checkpoints/setEditTask', value)
				}

			},

			valid: {
				get()
				{
					return this.$store.getters['checkpointsValidator/isValidEdit']
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater']
				}
			},

			video: {
				get()
				{
					return this.$store.getters['checkpoints/editableTask'].question.files[0]
				}
			},

			api: {
				get()
				{
					return APIURL
				}
			},

			isBeingReplaced: {
				get()
				{
					return this.$store.getters['checkpoints/isBeingReplaced'];
				},

				set(value)
				{

					this.$store.dispatch('checkpoints/setIsBeingReplacedGlobal', value)
				}
			}
		},

		

	}
</script>